//#region directives/focustrap_directive/focustrap_constants.js
var e = Object.freeze({
	active: !0,
	initialFocus: "auto",
	restoreFocus: !0
}), t = Symbol("dtFocustrap");
//#endregion
export { e as FOCUSTRAP_DEFAULTS, t as FOCUSTRAP_STATE_KEY };

//# sourceMappingURL=focustrap-constants.js.map